import React, { useEffect, useRef } from "react";
import { CSSTransition } from "react-transition-group";

import { useAnimationIn } from "../../hooks/useAnimationIn";
import { ANIMATION_TIME } from "../../utils";
import type { BottomSheetProps } from "../../BottomSheet";
import styles from "./Overlay.module.scss";

type OverlayProps = Pick<BottomSheetProps, "open" | "onClose">;

export const Overlay = ({ open, onClose }: OverlayProps) => {
  const overlayRef = useRef<HTMLDivElement>(null);
  const isAnimationIn = useAnimationIn(open);

  const preventDefault = (e: Event) => {
    e.preventDefault();
  };

  useEffect(() => {
    const initialOverflowValue = document.body.style.overflow;
    const overlay = overlayRef.current;

    document.body.style.overflow = "hidden";

    /*
     * Это нужно исключительно для Safari в iOS
     * в других браузерах достаточно навесить overflow: hidden на body
     * */
    if (overlay) {
      overlay.addEventListener("touchmove", preventDefault);
    }

    return () => {
      document.body.style.overflow = initialOverflowValue;

      if (overlay) {
        overlay.removeEventListener("touchmove", preventDefault);
      }
    };
  }, []);

  return (
    <CSSTransition
      timeout={ANIMATION_TIME}
      nodeRef={overlayRef}
      in={isAnimationIn}
      classNames={{
        enter: styles.overlay__enter,
        enterActive: styles.overlay__enter_active,
        exit: styles.overlay__exit,
        exitActive: styles.overlay__exit_active,
      }}
    >
      <div
        ref={overlayRef}
        className={styles.overlay}
        onClick={onClose}
        data-testid="overlay__wrapper"
      />
    </CSSTransition>
  );
};
